// extracted by mini-css-extract-plugin
module.exports = {"row":"Row_row__cDs_b","label":"Row_label__4RNQY","content":"Row_content__2_jY4"};